// extracted by mini-css-extract-plugin
module.exports = {"button":"CartButton_button__2XDr3","icon":"CartButton_icon__2DEon","badge":"CartButton_badge__2alTD","bump":"CartButton_bump__13gS-"};